import {Space} from "antd";
import {SessionGenInfoSessionLinkFormField} from "../../session/gen-info/session-link";
import {SessionGenInfoSessionDurationFormField} from "../../session/gen-info/session-duration";
import {SessionSubGenInfoFormFields} from "../../session/gen-info/sub-gen-info";

export function BundleSessionGenInfoFormFields() {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <SessionSubGenInfoFormFields
        coverImageFieldId="bundleSessionCoverImage"
        coverImageFieldLabel="Cover Image"
        coverImageFieldPlaceholder=""
        descriptionFieldId="bundleSessionDescription"
        descriptionFieldLabel="Bundle description"
        descriptionFieldPlaceholder="What is your session about"
        nameFieldId="bundleSessionName"
        nameFieldLabel="Bundle name"
        nameFieldPlaceholder="e.g Marketing 101"
      />
      <SessionGenInfoSessionLinkFormField
        id={"sessionSlug"}
        label="Bundle Link"
        placeholder="30-min"
      />
      <SessionGenInfoSessionDurationFormField
        callDurationFormFieldId="sessionCallDuration"
        callDurationFormFieldLabel="Session Duration"
        callDurationFormFieldPlaceholder="Please select a duration"
        customCallDurationFormFieldId="sessionCustomCallDuration"
        customCallDurationFormFieldLabel="Custom Duration (in minutes)"
        customCallDurationFormFieldPlaceholder="120"
      />
    </Space>
  );
}
